import i18n from "@/plugins/i18n";

/**
 * Reads a message exactly as it is written in the translation files, braces and
 * all.
 *
 * `t()` resolves `{placeholders}` while rendering, but describeFilter splits a
 * template on its placeholders to build individually styled segments, so it
 * needs the raw template rather than a finished sentence.
 */
const lookup = (locale: string, key: string): string | undefined => {
	const message = key
		.split(".")
		.reduce<unknown>(
			(node, part) =>
				node && typeof node === "object"
					? (node as Record<string, unknown>)[part]
					: undefined,
			i18n.global.getLocaleMessage(locale)
		);

	return typeof message === "string" ? message : undefined;
};

export const messageTemplate = (key: string): string =>
	lookup(i18n.global.locale.value, key) ?? lookup("en", key) ?? key;
